// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --page-margin: var(--app-fair-margin);
  --page-background: var(--app-background-alt-shade);
  --page-headers-shadow-color: rgba(var(--ion-color-darkest-rgb), 0.4);
}

.app-sidemenu ion-toolbar {
  --padding-start: 0px;
  --padding-end: 0px;
  --padding-top: 0px;
  --padding-bottom: 0px;
  --background: var(--ion-color-light-tint);
}
.app-sidemenu ion-content {
  --background: var(--ion-color-light-tint);
}
.app-sidemenu .user-details-wrapper {
  --ion-grid-column-padding: 0px;
  color: var(--ion-color-lightest);
  padding: var(--page-margin);
  align-items: center;
}
.app-sidemenu .user-details-wrapper + .user-details-wrapper {
  padding-top: 0px;
}
.app-sidemenu .user-info-wrapper .nombre-app {
  margin: 0px 0px 5px;
  font-size: 30px;
  font-family: "Typo", normal;
  text-align: center;
}
.app-sidemenu .user-info-wrapper .user-nombre {
  margin: 0px;
  font-size: 18px;
  font-weight: 350;
}
.app-sidemenu .user-info-wrapper .user-email {
  margin: 0px;
  font-size: 17px;
  font-weight: 300;
}
.app-sidemenu .user-info-wrapper .user-empresa {
  margin: 0px;
  font-size: 20px;
  font-weight: 400;
}
.app-sidemenu .user-stats-wrapper {
  text-align: center;
}
.app-sidemenu .user-stats-wrapper .user-stat-value {
  margin-right: 5px;
  font-weight: 500;
}
.app-sidemenu .user-stats-wrapper .user-stat-name {
  color: var(--ion-color-light-shade);
  font-size: 14px;
}
.app-sidemenu ion-list {
  --ion-text-color: var(--ion-color-light-shade);
  --ion-text-color-rgb: var(--ion-color-light-shade-rgb);
  --ion-item-background: var(--ion-color-medium-tint);
  --ion-item-border-color: transparent;
}
.app-sidemenu ion-list ion-list-header {
  --color: rgba(var(--ion-color-light-shade-rgb), 0.6);
  text-transform: uppercase;
  box-shadow: inset 0px -4px 8px -2px var(--page-headers-shadow-color);
  padding-inline-start: var(--page-margin);
  font-size: 14px;
  margin-bottom: 8px;
}
.app-sidemenu ion-list ion-item {
  --border-width: 0px !important;
  --padding-start: var(--page-margin);
  --background-activated: var(--ion-color-medium-tint);
}
.app-sidemenu ion-list ion-icon {
  color: var(--ion-color-light-shade);
}

@media (prefers-color-scheme: dark) {
  .app-sidemenu ion-toolbar {
    --background: var(--ion-color-light-tint);
  }
  .app-sidemenu ion-content {
    --background: var(--ion-color-medium-tint);
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/estilosMenu/side-menu.scss"],"names":[],"mappings":"AAGA;EACE,qCAAA;EACA,kDAAA;EAEA,oEAAA;AAHF;;AAQE;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yCAAA;AALJ;AAQE;EACE,yCAAA;AANJ;AASE;EACE,8BAAA;EAGA,gCAAA;EACA,2BAAA;EACA,mBAAA;AATJ;AAYI;EACE,gBAAA;AAVN;AAiBI;EACE,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;AAfN;AAkBI;EAEE,WAAA;EACA,eAAA;EACA,gBAAA;AAjBN;AAoBI;EAEE,WAAA;EACA,eAAA;EACA,gBAAA;AAnBN;AAqBI;EAEE,WAAA;EACA,eAAA;EACA,gBAAA;AApBN;AAwBE;EACE,kBAAA;AAtBJ;AAwBI;EACE,iBAAA;EACA,gBAAA;AAtBN;AAyBI;EACE,mCAAA;EACA,eAAA;AAvBN;AA4BE;EACE,8CAAA;EACA,sDAAA;EACA,mDAAA;EACA,oCAAA;AA1BJ;AA4BI;EACE,oDAAA;EAEA,yBAAA;EACA,oEAAA;EACA,wCAAA;EAEA,eAAA;EACA,kBAAA;AA5BN;AA+BI;EACE,8BAAA;EACA,mCAAA;EACA,oDAAA;AA7BN;AAgCI;EACE,mCAAA;AA9BN;;AAkCA;EAEI;IACE,yCAAA;EAhCJ;EAkCE;IACE,0CAAA;EAhCJ;AACF","sourcesContent":["// Custom variables\r\n\r\n// Note:  These ones were added by us and have nothing to do with Ionic CSS Custom Properties\r\n:host {\r\n  --page-margin: var(--app-fair-margin);\r\n  --page-background: var(--app-background-alt-shade);\r\n\r\n  --page-headers-shadow-color: rgba(var(--ion-color-darkest-rgb), 0.4);\r\n}\r\n\r\n// Note:  All the CSS variables defined below are overrides of Ionic elements CSS Custom Properties\r\n.app-sidemenu {\r\n  ion-toolbar {\r\n    --padding-start: 0px;\r\n    --padding-end: 0px;\r\n    --padding-top: 0px;\r\n    --padding-bottom: 0px;\r\n    --background: var(--ion-color-light-tint);\r\n  }\r\n\r\n  ion-content {\r\n    --background: var(--ion-color-light-tint);\r\n  }\r\n\r\n  .user-details-wrapper {\r\n    --ion-grid-column-padding: 0px;\r\n\r\n    // background-color: rgba(var(--ion-color-light-rgb), 0.15);\r\n    color: var(--ion-color-lightest);\r\n    padding: var(--page-margin);\r\n    align-items: center;\r\n    \r\n\r\n    & + .user-details-wrapper {\r\n      padding-top: 0px;\r\n    }\r\n  }\r\n\r\n  .user-info-wrapper {\r\n    //padding-left: var(--page-margin);\r\n\r\n    .nombre-app {\r\n      margin: 0px 0px 5px;\r\n      font-size: 30px;\r\n      font-family: 'Typo' , normal;\r\n      text-align: center;\r\n    }\r\n\r\n    .user-nombre {\r\n      //color: var(--ion-color-light-shade);\r\n      margin: 0px;\r\n      font-size: 18px;\r\n      font-weight: 350;\r\n    }\r\n\r\n    .user-email {\r\n      //color: var(--ion-color-light-shade);\r\n      margin: 0px;\r\n      font-size: 17px;\r\n      font-weight: 300;\r\n    }\r\n    .user-empresa {\r\n      //color: var(--ion-color-light-shade);\r\n      margin: 0px;\r\n      font-size: 20px;\r\n      font-weight: 400;\r\n    }\r\n  }\r\n\r\n  .user-stats-wrapper {\r\n    text-align: center;\r\n\r\n    .user-stat-value {\r\n      margin-right: 5px;\r\n      font-weight: 500;\r\n    }\r\n\r\n    .user-stat-name {\r\n      color: var(--ion-color-light-shade);\r\n      font-size: 14px;\r\n    }\r\n  }\r\n\r\n  // Menu list items\r\n  ion-list {\r\n    --ion-text-color: var(--ion-color-light-shade);\r\n    --ion-text-color-rgb: var(--ion-color-light-shade-rgb);\r\n    --ion-item-background: var(--ion-color-medium-tint);\r\n    --ion-item-border-color: transparent;\r\n\r\n    ion-list-header {\r\n      --color: rgba(var(--ion-color-light-shade-rgb), 0.6);\r\n\r\n      text-transform: uppercase;\r\n      box-shadow: inset 0px -4px 8px -2px var(--page-headers-shadow-color);\r\n      padding-inline-start: var(--page-margin);\r\n\r\n      font-size: 14px;\r\n      margin-bottom: 8px;\r\n    }\r\n\r\n    ion-item {\r\n      --border-width: 0px !important;\r\n      --padding-start: var(--page-margin);\r\n      --background-activated: var(--ion-color-medium-tint);\r\n    }\r\n\r\n    ion-icon {\r\n      color: var(--ion-color-light-shade);\r\n    }\r\n  }\r\n}\r\n@media (prefers-color-scheme: dark) {\r\n  .app-sidemenu   { \r\n    ion-toolbar {\r\n      --background : var(--ion-color-light-tint);\r\n    }\r\n    ion-content {\r\n      --background: var(--ion-color-medium-tint);\r\n    }\r\n    \r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
